import { Directive } from '@angular/core';

@Directive({
  selector: '[libMaterialBlock]'
})
export class MaterialBlockDirective {}
